export default __webpack_public_path__ + "static/media/ZW.3a5b1eb9.svg";